import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iplisting',
  templateUrl: './iplisting.component.html',
  styleUrls: ['./iplisting.component.scss']
})
export class IPListingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
